import {
  getInitialFlightList,
  INITIALIZE_APP,
  periodicConfigurationFetch,
  startPeriodicDataFetch,
  stopPeriodicConfigurationFetch,
  stopPeriodicDataFetch,
  UNINITIALIZE_APP,
  updateActiveAircraft,
  updateActiveFlight,
  updateAircraftList,
  updateConfiguration,
  updateCurrentTime,
  updateFlightList,
  getUser,
} from 'actions';
import config from 'config';
import store from 'store';

const fiveMinInterval = 5 * 60 * 1000;

export const initializeApp = (user) => {
  const { initialized, aircraftList } = store.getState();

  if (!initialized) {
    return async (dispatch) => {
      await dispatch(updateConfiguration());
      const { configuration } = store.getState();
      let fetchData = !configuration.maintenance_mode;

      // Calculate all the dates
      const todayDate = new Date();
      const fiveMinAgo = todayDate.getTime() - fiveMinInterval;
      const dt1DayAgo = new Date().getTime() - 24 * 60 * 60 * 1000;
      const dt7DaysAgo = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;

      let fetchTime = dt7DaysAgo;

      if (aircraftList) {
        // Get the latest modified date from aircraft list
        const latestmodifiedDt = Math.max(
          ...aircraftList.map((aircraft) => new Date(aircraft.modified)),
        );

        // If latest modified date is older than 5 mins than fetch the data
        fetchData = fetchData && latestmodifiedDt < fiveMinAgo;

        // If latest modified date is older than a day than fetch everything
        // Else Fetch data for last 24 hrs.
        fetchTime =
          fetchData && latestmodifiedDt > dt1DayAgo ? dt1DayAgo : dt7DaysAgo;
      }

      const promises = [];
      const initailFlightAPIPageSize = 1000;

      promises.push(dispatch(getUser(user)));
      promises.push(dispatch(updateCurrentTime()));
      if (fetchData) {
        promises.push(dispatch(updateAircraftList()));
        promises.push(dispatch(updateActiveAircraft()));
      }
      await Promise.all(promises);

      // Get all the current flights if fetchTime is 7 days ago.
      if (fetchData) {
        const { aircraftList: aircrafts } = store.getState();
        let currentFlightIds = [];
        aircrafts?.forEach((aircraft) => {
          const id = aircraft.flights?.at(0)?.id;
          if (id) currentFlightIds.push(id);
        });
        await dispatch(getInitialFlightList(currentFlightIds, fetchTime));
      }

      dispatch({
        type: INITIALIZE_APP,
      });

      if (fetchData) {
        // Lazy load of all the flights once UI is loaded
        dispatch(updateFlightList(fetchTime, initailFlightAPIPageSize));
        dispatch(updateActiveFlight());
      }

      setTimeout(() => dispatch(periodicConfigurationFetch()), fiveMinInterval);
      setTimeout(
        () => dispatch(startPeriodicDataFetch()),
        config.app.refreshInterval,
      );
    };
  } else {
    return async () => {};
  }
};

export const unititializeApp = () => {
  return async (dispatch) => {
    dispatch({
      type: UNINITIALIZE_APP,
    });

    dispatch(stopPeriodicConfigurationFetch());
    dispatch(stopPeriodicDataFetch());
  };
};
